module.exports = __webpack_public_path__ + "img/diamond-1.8d648590.png";